import { useSelector } from 'react-redux';
import { UserProfileResult } from '@mews-commander/data-access';
import { useCurrentUser } from '@mews-commander/core';
import { hasPlatformScopeWithAccessAllEnterprises } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { isCurrentProfileAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';

export const useTableActionsInfo = (userProfile: Pick<UserProfileResult, 'userId' | 'isAdmin' | 'properties'>) => {
    const { id: currentUserId } = useCurrentUser();
    const isOwnProfile = userProfile.userId === currentUserId;
    const isUserAdmin: boolean = useSelector(isCurrentProfileAdmin);
    const canAccessAllEnterprises = useSelector(hasPlatformScopeWithAccessAllEnterprises);
    const hasNoProperties = userProfile.properties === 0;

    return {
        isOwnProfile,
        isActionDisabled:
            isOwnProfile || (!isUserAdmin && !!userProfile.isAdmin && !canAccessAllEnterprises) || hasNoProperties,
        hasNoProperties,
    };
};
